<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";

    import PhotoReviewItemFrame from "./ReviewsMasonryItemFrame.svelte";

    const randomHeight = `${Math.round(Math.random() * (160 - 50)) + 50}px`;
</script>

<PhotoReviewItemFrame>
    <svelte:fragment slot="media">
        <ImageSkeleton ratio={1 / 1} />
    </svelte:fragment>

    <svelte:fragment slot="rating">
        <BaseSkeleton width="30%" height="20px" />
    </svelte:fragment>

    <svelte:fragment slot="date">
        <BaseSkeleton width="30%" height="28px" />
    </svelte:fragment>

    <svelte:fragment slot="title">
        <BaseSkeleton width="100%" height="18px" />
    </svelte:fragment>

    <svelte:fragment slot="text">
        <BaseSkeleton width="100%" height={randomHeight} />
    </svelte:fragment>
</PhotoReviewItemFrame>
